import ApiClient from "./ApiClient";

let organisationId = null;

const ZatcaClientFactory = () => {
  return () =>
    ApiClient({
      baseURL: `/api/zatca/${organisationId ?? 0}`,
    });
};

export const setOrganisationId = (id) => {
  organisationId = id;
};

const ZatcaClient = ZatcaClientFactory();

export default ZatcaClient;


